<template>
  <form class="resetpassword-form" @submit.prevent="onSubmit">
    <slot></slot>

    <template v-if="!data.resetLinkSent">
      <h1 class="title">{{ $t("headings.resetPassword") }}</h1>

      <p>{{ $t("texts.resetPasswordInstructions") }}</p>

      <input-text
        v-model:value="data.emailValue"
        :label="$t('labels.email')"
        :required="true"
        :autofocus="true"
        type="email"
        style="text-align: left"
      />

      <div v-show="!!data.error" class="message-error mt-2">
        {{ data.error }}
      </div>

      <button class="button mt-4" type="submit">
        {{ $t("actions.resetPassword") }}
      </button>
    </template>
    <template v-else>
      <p>
        {{ $t("texts.passwordResetLinkSent") }}
      </p>
    </template>
    <slot name="footer"></slot>
  </form>
</template>

<script setup lang="ts">
import { watch, reactive } from "vue";
import { post } from "@/api/API";

import InputText from "@core/input/InputText.vue";

const {
  email = ""
} = defineProps<{
  email?: string;
}>();
const emit = defineEmits<{
  (e: "update:email", value: string): void;
}>();

const data = reactive({
  emailValue: "",
  resetLinkSent: false,
  error: ""
});

watch(() => email, (value) => {
  data.emailValue = value;
}, { immediate: true });

watch(() => data.emailValue, (value, oldValue) => {
  if (value != oldValue) {
    data.error = "";
  }
  if (email != value) {
    emit("update:email", value);
  }
});

async function onSubmit() {
  try {
    const body = await post("/request_password_reset_email/", {
      data: {
        email: data.emailValue
      },
      sendAuthToken: false
    });
    console.log(body);
    data.resetLinkSent = true;
  } catch (e) {
    const error = e as Error;
    console.log("error", error);
    data.error = error.message;
  }
}
</script>

<style lang="scss">
.resetpassword-form {
  text-align: center;
  width: 100%;
  max-width: 30rem;

  p {
    text-align: left;
  }

  .input__container {
    text-align: inline-start;
  }
}
</style>
